/**
 * Prevent user from continue if add/edit comment is open
 */
Core.CheckoutCommentContinueBtnCheck = function() {
    var data = new Set();
    var btn = document.querySelector('[data-btn="product-continue"]');

    var m = {
        openCommentForm: function(COMMENT_FORM_ID) {
            data.add(COMMENT_FORM_ID);
            m.updateBtn();
        },

        closeCommentForm: function(COMMENT_FORM_ID) {
            data.delete(COMMENT_FORM_ID);
            m.updateBtn();
        },

        updateBtn: function() {
            btn &&
                (btn.disabled = data.size > 0);
        }
    };

    return m;
};